module.exports = __webpack_public_path__ + "img/icn_landing_strong.c92e9721.svg";